import { NgxSmartModalService } from 'ngx-smart-modal';
import { ViewChild, Type, Directive } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { IServiceBase } from '../services/base/IServiceBase';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Observable } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import { HttpParams, HttpClient, HttpHandler } from '@angular/common/http';

import { Utilidades } from './utilidades';
import { PageList } from '../models/pageList.model';
import { SortGrid } from '../models/sortGrid.model';
import { FilterGrid } from '../models/filterGrid.model';
import { ArrayDataSource } from '@angular/cdk/collections';
import { CustomFilter } from '../models/customFilter.model';
import { EQueryOperator } from '../Enums/EQueryOperator.enum';
//import { FilterService } from '../services/core/filter.service';

import { EFieldType } from '../Enums/EFieldType.enum';
import { EnumQueryLinkType } from '../Enums/EQueryLinkType.enum';
import { BaseModel } from '../models/base/base.model';

@Directive()
export class ListFormBase<T extends BaseModel>{
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  isCrud: boolean;
  isModalEdit = false;
  showToolbarAddons = false;
  dataSource: any;
  modelId: any;
  parentId: any;
  smartModalId: string;

  baseModel: BaseModel = new BaseModel();

  dxDataGridCustomAction = [
    'skip',
    'take',
    'requireTotalCount',
    'requireGroupCount',
    'sort',
    'filter',
    'totalSummary',
    'group',
    'groupSummary'
  ];

  constructor(
    protected _modelService: IServiceBase<T>,
    protected _router: Router,
    protected _activatedRoute: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    //protected _filterService: FilterService,
    private tType: new () => T,
    protected _ngxSmartModalService?: NgxSmartModalService
  ) {
    this.modelId = undefined;
    this.smartModalId = '';
  }

  /**
   * @description
   * Obtiene el identificador del modelo desde la ruta.
   **/
  getIdFromRoute() {
    this._activatedRoute.params.subscribe(params => {
      this.parentId = params['id'] as number;
    });
  }


  /**
   * @description
   * Genera un Custom datasource necesario para realizar el paginado del grid contra el BackEnd
   * @param key
   * Primary key de los datos a mostrar
   * @param idParent
   * [Opcional] Identificador del padre, por si los datos a obtener dependen de una relación superior
   **/
  getCustomDataSource(key: string, idParent?: string | number) {
    this.dataGrid.instance.beginCustomLoading('');

    let observable: Observable<PageList<T>>;

    this.dataSource = new CustomStore({
      key: key,
      load: function(loadOptions: any) {
        let params: HttpParams = new HttpParams();

        // Gestionamos las opciones de carga para procesar las acciones de filtrado, paginado
        // y orden
        params = this.getActionsParams(loadOptions);
        observable = this._modelService.getPagedModels(idParent, params);
        return this.getDataObjectForCustomSource(observable);

      }.bind(this)
    });

    return;
  }

  /**
   * @description
   * genera los parámetros según los valores de las custom actions del grid y las procesa para el endpoint.
   * El filtro no se procesa en éste método.
   * @param loadOptions
   * Array con las opciones de carga del grid de devExtreme (Se optienen al implementar el método load del CustomStore)
   */
  private getActionsParams(loadOptions: any[]) {
     let params: HttpParams = new HttpParams();

     this.dxDataGridCustomAction.forEach(
          function(action) {
            const loadOption = loadOptions[action];
            if (action in loadOptions && Utilidades.isNotEmpty(loadOption)) {
              let dollarAction = `$${action}`;
              switch (action) {
                case 'skip': {
                  params = params.set(dollarAction, JSON.stringify(loadOption));
                  break;
                }
                case 'take': {
                  params = params.set('$top', JSON.stringify(loadOption));
                  break;
                }
                case 'sort': {
                  if (SortGrid.isSortGrid(loadOption[0])) {
                    const sort: SortGrid = loadOption[0];
                    params = params.set('$orderby',  `${sort.selector} ${sort.desc ? 'desc': 'asc'}`);
                  }
                  break;
                }
                case 'filter': {
                  let filter:string = '';
                  if (Array.isArray(loadOption) && loadOption.length > 1) {
                    if (!Utilidades.isString(loadOption[0])) {
                      loadOption.forEach(element => {
                        if (Utilidades.isString(element)) {
                          filter = `${filter} ${element}` ;
                        } else {
                          const fGrid: FilterGrid = new FilterGrid(element);
                          filter = `${filter} ${fGrid.toString()}` ;
                        }
                      });
                    } else {
                      const fGrid: FilterGrid = new FilterGrid(loadOption);
                      filter = fGrid.toString();
                    }
                  }
                  params = params.set(dollarAction, filter);
                }
              }
            }
          }.bind(this)
    );
    return params;
  }


  /**
   * @description
   * Obtiene el dataSource con el que rellenar el dataGrid.
   * @param idParent
   * [Opcional] Identificador del elemento padre por el que se desea obtener los modelos
   */
  getDataSource(idParent?: any) {
    this.dataGrid.instance.beginCustomLoading('');

    let observable: Observable<T[]>;

    if (idParent) {
      observable = this.getAllModelsByParent(idParent);
    } else {
      observable = this.getAllModels();
    }
    // console.log("getDataSource");
    observable.subscribe(
      response => {
        let data = []

        if(response !== null){

          for (var i = 0; i < response.length; i++) {
            data.push(Object.assign(new this.tType(), response[i]));
          }

          //data = Object.assign(new Array<T>(), response)
        }

        // console.log(data);

        this.dataSource = data;
        // this.dataSource = response === null ? [] : response;
        this.dataGrid.instance.endCustomLoading();
      },
      err => {
        console.error(err);
        this.dataGrid.instance.endCustomLoading();
      }
    );
  }

  /**
   * @description
   * Genera un objeto CustomFilter a través del objeto FilterGrid que es la representación del filtro devuelto por el grid.
   * @param fGrid
   * Parámetro del tipo FilterGrid
   */
  private getCustomFilter(fGrid: FilterGrid): CustomFilter {
    const cFilterItem = new CustomFilter();
    cFilterItem.fieldName = BaseModel.getFieldName(this.tType, fGrid.field) || fGrid.field;
    //cFilterItem.operator = fGrid.getEndPointOperator();
    cFilterItem.fieldType = `${BaseModel.getfieldType(this.tType, fGrid.field) || EFieldType.string}`;
    cFilterItem.linkType = null;


    if (BaseModel.getfieldType(this.tType, fGrid.field) === EFieldType.date) {
      const dateValue: Date = new Date(fGrid.value);
      const dateString = `${dateValue.getDate()}/${dateValue.getMonth() + 1}/${dateValue.getFullYear()} 00:00:00`;
      cFilterItem.values.push(dateString);
    } else {
      cFilterItem.values.push(fGrid.value);
    }

    return cFilterItem;
  }




  /**
   * @description
   * Genera el objeto necesario para la carga de los datos del evento load del CustomSource del grid.
   * @param observable Parametro con el Observable con el que obtener los datos finales.
   */
  public getDataObjectForCustomSource(observable: Observable<T[]>) {
    return observable
      .toPromise()
      .then((data: any) => {
        this.dataGrid.instance.endCustomLoading();
        if (PageList.isPageList(data)) {
          return {
            data: data.pageData,
            totalCount: data && data.pagination ?  data.pagination.totalCount : 0,
            summary: 0,
            groupCount: 0
          };
        }
        return {
          data: data,
          totalCount: data ? data.length : 0,
          summary: 0,
          groupCount: 0
        };
      })
      .catch(error => {
        this.dataGrid.instance.endCustomLoading();
        throw new Error(`Error al cargar los datos ${error}`);
      });
  }

  /**
   * @description
   * Obtiene todos los modelos del tipo T indicado.
   * */
  getAllModels(params?: HttpParams) {
    return this._modelService.getAllModels(null, params);
  }

  /**
   * @description
   * Obtiene un listado de elementos según el identificador común de un elemento padre.
   * @param idParent
   * Identificador del elemento padre por el que se desea obtener los modelos
   * */
  getAllModelsByParent(idParent: any) {
    return this._modelService.getAllModels(idParent);
  }

  delete(id: any, rowIndex: number, rowVersion?: number) {
    let obs: Observable<any>;

    if (rowVersion) {
      obs = this._modelService.deleteWithRowVersion(id, rowVersion, this.parentId);
    } else {
      obs = this._modelService.delete(id, this.parentId);
    }
    obs.subscribe(
      res => {
        this._messageDialog.ShowMessage(
          'El elemento seleccionado ha sido borrado.',
          'Borrado'
        );
        this.dataGrid.instance.deleteRow(rowIndex);
      },
      err => {
        console.error(err);
        this._messageDialog.ShowException(err);
      }
    );
  }

  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  refreshGrid() {
    this.dataGrid.instance.refresh();
  }

  // **********************************************//
  //             Eventos
  // **********************************************//

  onToolbarPreparing(e) {

    const newButtonTemplate = {
      location: 'after',
      template: 'addNew'
    };

    if (this.isCrud) {
      e.toolbarOptions.items.unshift(newButtonTemplate);
    }

    if (this.showToolbarAddons) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          template: 'addons'
        });
    }
  }

  onEditorPreparing(e) {
    if (e.parentType === "searchPanel") {
        e.editorOptions.stylingMode = "underlined";
    }
  }

  onClickDelete(id: any, rowIndex: number, rowVersion?: number) {
    this._messageDialog
      .ShowQuestion(
        'ésta acción no se podrá revertir',
        '¿confirma la eliminación?'
      )
      .then(result => {
        if (result.value) {
          this.delete(id, rowIndex, rowVersion);
        }
      });
  }

  onClickEdit(id: any) {
    this.modelId = id;
    if (this.isModalEdit) {
      if (this._ngxSmartModalService) {
        this._ngxSmartModalService.getModal(this.smartModalId).open();
      }
    } else {
      this._router.navigate([id], {
        relativeTo: this._activatedRoute
      });
    }
  }

  onClickEditEmpleados(id: any, companyCode: number) {
    this.modelId = id;
    if (this.isModalEdit) {
      if (this._ngxSmartModalService) {
        this._ngxSmartModalService.getModal(this.smartModalId).open();
      }
    } else {
      this._router.navigate([id], {
        relativeTo: this._activatedRoute,
        queryParams: { companyCode: companyCode } 
      });
    }
  }

  onClickAdd() {
    this.modelId = undefined;
    if (this.isModalEdit) {
      if (this._ngxSmartModalService) {
        this._ngxSmartModalService.getModal(this.smartModalId).open();
      }
    } else {
      this._router.navigate(['new'], {
        relativeTo: this._activatedRoute
      });
    }
  }
}
